import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { deleteDiscovery } from 'action/discovery'
import PropTypes from 'prop-types'
import confirmModal from 'view/component/confirm-modal'

const generateModalText = (title) => ({
  decide: {
    content: 'This action cannot be undone',
    title: `Are you sure you want to delete ${title}?`
  },

  outcome: {
    content: {
      error: 'Please try Again',
      success: `${title} has been successfully deleted`
    },
    title: {
      error: `There has been an issue deleting ${title}`,
      success: 'Discovery deleted'
    }
  }
})

const DeleteDiscovery = ({ deleteDiscovery, discovery: { uuid, title }, pagination }) => {
  const handleSubmit = () => deleteDiscovery(uuid)

  const { decide, outcome } = generateModalText(title)

  return (
    <a onClick={() => confirmModal(handleSubmit, decide, outcome)}>Delete Discovery</a>
  )
}

DeleteDiscovery.propTypes = {
  deleteDiscovery: PropTypes.func,
  discovery: PropTypes.object,
  pagination: PropTypes.object
}

const mapDispatchToProps = (dispatch) => ({
  deleteDiscovery: bindActionCreators(deleteDiscovery, dispatch)
})

const mapStateToProps = (state) => ({
  pagination: state.discovery.pagination
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteDiscovery)
